import type { NavigationFailure, RouteLocationNormalized } from 'vue-router';
import store from '@/store';
import { recentVisitService } from '@/services/v2/RecentVisitService';
import type { User } from '@/types/User';
import { IsUserABroker, IsUserAnAdmin } from '@/utilities/AuthUtils';

const ACCOUNT_ROUTE_PATH = '/account/:id';

function visitedAccountId(route: RouteLocationNormalized): number | null {
  if (!route.matched.some((record) => record.path === ACCOUNT_ROUTE_PATH)) {
    return null;
  }
  const rawId = String(route.params.id ?? '');
  if (!/^\d+$/.test(rawId)) {
    return null;
  }
  const accountId = Number(rawId);
  return accountId > 0 ? accountId : null;
}

// Role checks also read Client View state, so "View as Client" sessions resolve to the client role and are skipped;
// the shared `post` helper sends no client-view headers, so the API's own no-op would never trigger.
export function accountVisitToRecord(to: RouteLocationNormalized, from: RouteLocationNormalized, user: User | undefined): number | null {
  if (!IsUserAnAdmin(user) && !IsUserABroker(user)) {
    return null;
  }
  const accountId = visitedAccountId(to);
  if (accountId === null || visitedAccountId(from) === accountId) {
    return null;
  }
  return accountId;
}

export function recordRecentAccountVisit(
  to: RouteLocationNormalized,
  from: RouteLocationNormalized,
  failure: NavigationFailure | void | undefined,
): void {
  if (failure) {
    return;
  }
  const accountId = accountVisitToRecord(to, from, store.state.user);
  if (accountId !== null) {
    void recentVisitService.record('account', accountId);
  }
}
